import { Component, input } from '@angular/core';

@Component({
  selector: 'mbm-form-error',
  templateUrl: './mbm-form-error.component.html',
  styleUrl: './mbm-form-error.component.scss',
  imports: []
})
export class MbmFormErrorComponent {
  readonly message = input<string | null | undefined>(undefined);
}
